var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPersonal = function SvgPersonal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "personal_svg__Capa_2",
    viewBox: "0 0 34.41 57.18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "personal_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.88 30.43c6.89 0 12.47-5.65 12.47-12.63S23.77 5.18 16.88 5.18 4.41 10.83 4.41 17.8s5.58 12.63 12.47 12.63",
    fill: "#aaeee8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.05 31.97h12.31c6.1 0 11.06 5.01 11.06 11.2v8.48c0 3.05-2.45 5.53-5.47 5.53H5.47C2.45 57.18 0 54.7 0 51.65v-8.48c0-6.17 4.95-11.2 11.06-11.2Z",
    fill: "#2ad2c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.49 31.97c0 3.51-2.81 6.36-6.29 6.36s-6.29-2.85-6.29-6.36h12.57Z",
    fill: "#aaeee8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6 15.64s4.71 1.1 10.63-.89c0 0 .8 1.12 3.36.59 2.56-.51 4.02-2.73 4.02-2.73s1.38 3.03 6.64 3.78c0 0 .29 1.98-.29 4.44 0 0 2.86-3.49 2.32-9-.5-5.15-4.14-8.07-7.29-7.56 0 0-5.72-6.68-14.86-3.31-11.34 4.18-8.12 17.35-4.55 18.96 0 0-.24-1.98.02-4.29Z",
    fill: "#22aa9f"
  }))));
};
export default SvgPersonal;